<template>
<div class="main-n" :style="portalThemeStyles">
  
     <div  v-if="dropdownMenu && isLoggedIn"  class="dropdown-menu-x">

     <div v-if="!isLoggingOut">
      <div class="user-card">
        <div class="avatar avatar-lg">{{ userInitials }}</div>
        <div class="user-card-body">
          <div class="user-card-name">{{ displayName }}</div>
          <div class="user-card-email">{{ userEmail }}</div>
          <div class="chip-row">
            <div class="chip chip-primary">{{ userRoleLabel }}</div>
            <div v-if="companyName" class="chip chip-secondary">{{ companyName }}</div>
          </div>
        </div>
      </div>

      <div class="dropdown-section">
        <router-link class="dropdown-item" to="/Profile" @click.native="handleDropdownNavigate">
          <div class="item-icon">
            <b-icon icon="person-circle"></b-icon>
          </div>
          <div class="item-copy">
            <span class="item-title">Mi perfil</span>
            <span class="item-subtitle">Gestiona tu cuenta y contraseña</span>
          </div>
        </router-link>
      </div>

      <div class="dropdown-section">
        <button class="dropdown-item logout" type="button" @click="sendLogOut">
          <div class="item-icon">
            <b-icon icon="box-arrow-right"></b-icon>
          </div>
          <div class="item-copy">
            <span class="item-title">Cerrar sesión</span>
            <span class="item-subtitle">Salir de la plataforma</span>
          </div>
        </button>
      </div>

      <p class="dropdown-footer-note">Sobre Jobbing.cl · Más información</p>

  </div>
  <div v-else class="loader-wrapper">
    <div class="spinner-border text-secondary" role="status"></div>
    <div class="loader-text">Cerrando sesión...</div>
  </div>

   </div>


  <div class="main-top-nav">

      <div class="logo">
        <button
          v-if="window.width < 800"
          type="button"
          class="mobile-menu-button"
          aria-controls="admin-mobile-navigation"
          :aria-expanded="sideMenu"
          :aria-label="sideMenu ? 'Cerrar menú de navegación' : 'Abrir menú de navegación'"
          @click="CambiarMenuAction({})"
        >
          <b-icon icon="list" aria-hidden="true" />
        </button>
          
        <div
          v-if="window.width < 800 && !sideMenu"
          class="top-brand-logo-frame"
        >
          <img :src="mobileBrandLogo" class="top-brand-logo" alt="Jobbing">
        </div>
      </div>

        <div
          v-if="showUniversalSearch"
          class="universal-search dontClose"
          :class="{ active: searchOpen }"
        >
          <b-icon icon="search" class="universal-search-icon dontClose" />
          <input
            v-model="searchQuery"
            type="text"
            class="universal-search-input dontClose"
            placeholder="Buscar ordenes, profesionales o clientes"
            autocomplete="off"
            @focus="handleSearchFocus"
            @input="handleSearchInput"
            @keydown.down.prevent="moveSearchSelection(1)"
            @keydown.up.prevent="moveSearchSelection(-1)"
            @keydown.enter.prevent="openSelectedSearchResult"
            @keydown.esc.prevent="clearUniversalSearch"
          >
          <button
            v-if="searchQuery"
            type="button"
            class="search-clear-button dontClose"
            aria-label="Limpiar busqueda"
            @click="clearUniversalSearch"
          >
            <b-icon icon="x" />
          </button>

          <div v-if="searchOpen" class="universal-search-results dontClose">
            <div v-if="searchLoading" class="universal-search-state dontClose">
              <div class="spinner-border spinner-border-sm text-secondary dontClose" role="status"></div>
              <span class="dontClose">Buscando...</span>
            </div>
            <div v-else-if="searchError" class="universal-search-state error dontClose">
              {{ searchError }}
            </div>
            <template v-else-if="searchResults.length">
              <div
                v-for="group in searchResultGroups"
                :key="group.type"
                class="search-group dontClose"
              >
                <div class="search-group-title dontClose">{{ group.label }}</div>
                <button
                  v-for="result in group.items"
                  :key="`${result.type}-${result.id}`"
                  type="button"
                  class="search-result-row dontClose"
                  :class="{
                    selected: selectedSearchResultKey === resultKey(result),
                    'search-client-row': result.type === 'cliente'
                  }"
                  @mousedown.prevent="openSearchResult(result)"
                >
                  <template v-if="result.type === 'cliente'">
                    <span class="search-result-icon search-client-icon dontClose">
                      <b-icon icon="person-lines-fill" />
                    </span>
                    <span class="search-client-copy dontClose">
                      <span class="search-client-heading dontClose">
                        <span class="search-result-title dontClose">{{ clientResultTitle(result) }}</span>
                        <span class="search-result-meta search-client-meta dontClose">{{ result.meta || 'Cliente' }}</span>
                      </span>
                      <span class="search-result-subtitle search-client-name dontClose">{{ result.title }}</span>
                      <span class="search-client-contact dontClose">{{ clientResultContact(result) }}</span>
                    </span>
                    <span class="search-client-open dontClose" aria-hidden="true">
                      <b-icon icon="arrow-right-short" />
                    </span>
                  </template>
                  <template v-else>
                    <span class="search-result-icon dontClose">
                      <b-icon :icon="result.icon || 'search'" />
                    </span>
                    <span class="search-result-copy dontClose">
                      <span class="search-result-title dontClose">{{ result.title }}</span>
                      <span class="search-result-subtitle dontClose">{{ result.subtitle }}</span>
                    </span>
                    <span class="search-result-meta dontClose">{{ result.meta }}</span>
                  </template>
                </button>
              </div>
            </template>
            <div v-else-if="searchQuery.trim().length >= 2" class="universal-search-state dontClose">
              Sin resultados.
            </div>
            <div v-else class="universal-search-hint dontClose">
              Escribe al menos 2 caracteres.
            </div>
          </div>
        </div>

      

        <!--
      <div class="buscar-barra">
        <input type="text" class="input-buscar dontClose" placeholder="Busca un paciente por nombre o rut" v-model="buscando">

        <div v-if="mostrando" class="buscar-resultados">
          <div v-if="!cargando">
            <div v-if="resultados.length>0" class="resultado" v-for="r, i in resultados">
              <router-link tag="div" style="cursor:pointer;" class="" :to="'/Paciente/'+r.id">   
              <b-icon icon="person" style="" class="buscandoIcons" /> {{r.nombre}} {{r.apellido1}} <div style="float:right; margin-top:5px;">{{r.rut}}-{{dgv(r.rut)}}</div> <hr v-if="i != resultados.length-1"/>
              </router-link>
            </div>
          <div v-if="resultados.length == 0" class="resultado">
                <span>¡No se encontraron pacientes!</span>
          </div>  
          </div>
          <div v-if="cargando">
            <div style="text-align:center;"><div class="spinner-border text-secondary" style=" " role="status"></div> Cargando... </div>
          </div>
        </div>
        <b-icon style="transform:translateX(-15px);" icon="search"></b-icon>
      </div>
      -->

        <div class="nav-actions" v-if="isLoggedIn">
          <button class="user-trigger" type="button" @click.prevent="toggleDropdown">
            <span class="avatar">{{ userInitials }}</span>
            <span class="user-meta">
              <span class="user-name">{{ displayName }}</span>
              <span class="user-role">{{ userRoleLabel }}</span>
            </span>
            <b-icon icon="chevron-down" class="trigger-icon" />
          </button>
        </div>
      

  </div>
  
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import axios from 'axios'

export default {
  
  name: 'TopNav',
  data(){
    return{
      dropdownMenu:false,
      isLoggingOut:false,
      buscando:'',
      resultados:[],
      mostrando: false,
      cargando:false,
      searchQuery: '',
      searchResults: [],
      searchOpen: false,
      searchLoading: false,
      searchError: '',
      searchDebounceTimer: null,
      searchRequestSeq: 0,
      selectedSearchIndex: -1,
       window: {
        width: 0,
        height: 0
      },
    }
  },
  components:{
  },
  watch:{


  },
    created () {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
    destroyed() {
    window.removeEventListener('resize', this.handleResize);

  },
  methods:{
    ...mapActions(['logoutpro', 'CambiarMenuAction']),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    isValidHexColor(color) {
      if (typeof color !== 'string') {
        return false;
      }
      const value = color.trim();
      return /^#?[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/.test(value);
    },
    normalizeHexColor(color) {
      if (!this.isValidHexColor(color)) {
        return null;
      }
      let hex = color.trim().replace('#', '');
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map((char) => `${char}${char}`)
          .join('');
      }
      return `#${hex.toLowerCase()}`;
    },
    adjustColor(hex, ratio) {
      const normalized = this.normalizeHexColor(hex);
      if (!normalized) {
        return hex;
      }

      const clampRatio = Math.max(-1, Math.min(1, ratio));
      const integer = parseInt(normalized.slice(1), 16);
      const channels = [
        (integer >> 16) & 0xff,
        (integer >> 8) & 0xff,
        integer & 0xff,
      ];

      const adjustChannel = (channel) => {
        const delta = clampRatio >= 0 ? (255 - channel) * clampRatio : channel * clampRatio;
        return Math.max(0, Math.min(255, Math.round(channel + delta)));
      };

      const [r, g, b] = channels.map(adjustChannel);
      const toHex = (channel) => channel.toString(16).padStart(2, '0');

      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    },
    hexToRgba(hex, alpha = 1) {
      const normalized = this.normalizeHexColor(hex);
      if (!normalized) {
        return `rgba(37, 99, 235, ${alpha})`;
      }
      const integer = parseInt(normalized.slice(1), 16);
      const r = (integer >> 16) & 0xff;
      const g = (integer >> 8) & 0xff;
      const b = integer & 0xff;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },


    sendLogOut(){
      this.isLoggingOut = true;
      setTimeout(()=>{this.isLoggingOut = false; this.logoutpro().then(this.$router.push('/Login'))}, 1500)
    },
    toggleDropdown (e) {
      this.dropdownMenu = !this.dropdownMenu
    },
    handleDropdownNavigate () {
      this.dropdownMenu = false
    },
    handleSearchFocus () {
      if (!this.showUniversalSearch) {
        return
      }
      this.searchOpen = true
      if (this.searchQuery.trim().length >= 2 && !this.searchResults.length) {
        this.runUniversalSearch()
      }
    },
    handleSearchInput () {
      this.searchOpen = true
      this.searchError = ''
      this.selectedSearchIndex = -1
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }
      const query = this.searchQuery.trim()
      if (query.length < 2) {
        this.searchResults = []
        this.searchLoading = false
        return
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.runUniversalSearch()
      }, 260)
    },
    runUniversalSearch () {
      const query = this.searchQuery.trim()
      if (query.length < 2) {
        return
      }
      const requestSeq = ++this.searchRequestSeq
      this.searchLoading = true
      this.searchError = ''
      axios.get(`${window.hostname}api/admin/universal_search`, {
        params: {
          q: query,
          limit: 5
        }
      }).then((response) => {
        if (requestSeq !== this.searchRequestSeq) {
          return
        }
        this.searchResults = Array.isArray(response.data.results) ? response.data.results : []
        this.selectedSearchIndex = this.searchResults.length ? 0 : -1
      }).catch((error) => {
        if (requestSeq !== this.searchRequestSeq) {
          return
        }
        console.error('Error searching admin entities', error)
        this.searchResults = []
        this.searchError = 'No se pudo buscar ahora.'
      }).finally(() => {
        if (requestSeq === this.searchRequestSeq) {
          this.searchLoading = false
        }
      })
    },
    resultKey (result) {
      if (!result) {
        return ''
      }
      return `${result.type}-${result.id}`
    },
    clientResultTitle (result) {
      if (!result || !result.id) {
        return 'Cliente'
      }
      return `Cliente #${result.id}`
    },
    clientResultContact (result) {
      if (!result) {
        return 'Sin contacto'
      }
      const title = result.title ? result.title.trim() : ''
      const subtitle = result.subtitle ? result.subtitle.trim() : ''
      if (subtitle && subtitle !== title) {
        return subtitle
      }
      return 'Sin contacto'
    },
    moveSearchSelection (direction) {
      if (!this.searchResults.length) {
        return
      }
      const nextIndex = this.selectedSearchIndex + direction
      if (nextIndex < 0) {
        this.selectedSearchIndex = this.searchResults.length - 1
      } else if (nextIndex >= this.searchResults.length) {
        this.selectedSearchIndex = 0
      } else {
        this.selectedSearchIndex = nextIndex
      }
    },
    openSelectedSearchResult () {
      if (!this.searchResults.length) {
        if (this.searchQuery.trim().length >= 2) {
          this.runUniversalSearch()
        }
        return
      }
      const result = this.searchResults[this.selectedSearchIndex >= 0 ? this.selectedSearchIndex : 0]
      this.openSearchResult(result)
    },
    openSearchResult (result) {
      if (!result || !result.to) {
        return
      }
      this.searchOpen = false
      this.searchQuery = ''
      this.searchResults = []
      this.selectedSearchIndex = -1
      this.$router.push(result.to).catch(() => {})
    },
    clearUniversalSearch () {
      this.searchQuery = ''
      this.searchResults = []
      this.searchOpen = false
      this.searchLoading = false
      this.searchError = ''
      this.selectedSearchIndex = -1
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
        this.searchDebounceTimer = null
      }
    },
    close (e) {
      if (!this.$el.contains(e.target)) { /*Si clickeo (e.target) fuera de este componente (this.$el), se cierra*/
        if (!(e.target.classList.contains('linky')))
          this.dropdownMenu = false
      }
      const keepSearchOpen = e.target.closest && e.target.closest('.dontClose')
      if (!keepSearchOpen)
      {
        this.mostrando = false
        this.buscando = '';
        this.searchOpen = false
      }
    },
  },
  computed: {
    ...mapGetters(['admin_datos', 'isLoggedIn', 'sideMenu']),
    showUniversalSearch () {
      if (!this.isLoggedIn || !this.admin_datos) {
        return false
      }
      return this.admin_datos.user_type !== 'property_manager' && this.admin_datos.user_type !== 'lead_partner'
    },
    searchResultGroups () {
      const labels = {
        orden: 'Ordenes',
        profesional: 'Profesionales',
        cliente: 'Clientes'
      }
      const order = ['orden', 'profesional', 'cliente']
      return order
        .map(type => ({
          type,
          label: labels[type],
          items: this.searchResults.filter(result => result.type === type)
        }))
        .filter(group => group.items.length)
    },
    selectedSearchResultKey () {
      if (this.selectedSearchIndex < 0 || !this.searchResults[this.selectedSearchIndex]) {
        return ''
      }
      return this.resultKey(this.searchResults[this.selectedSearchIndex])
    },
    tenantAtributos () {
      if (!this.admin_datos) {
        return null
      }
      if (this.admin_datos.user_type === 'property_manager') {
        return this.admin_datos.empresa && this.admin_datos.empresa.atributos
          ? this.admin_datos.empresa.atributos
          : null
      }
      if (this.admin_datos.user_type === 'lead_partner') {
        return this.admin_datos.lead_partner && this.admin_datos.lead_partner.atributos
          ? this.admin_datos.lead_partner.atributos
          : null
      }
      return null
    },
    brandLogo () {
      const atributos = this.tenantAtributos
      return (atributos && (atributos.logo_filename || atributos.logo_url || atributos.logo)) || require('@/assets/logo-jobbing-nuevo.webp')
    },
    mobileBrandLogo () {
      const baseUrl = process.env.BASE_URL || '/'
      const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
      return `${normalizedBaseUrl}favicon-192x192.png`
    },
    tenantBrandColor () {
      const atributos = this.tenantAtributos
      const color = atributos && atributos.color ? atributos.color : null

      if (!this.isValidHexColor(color)) {
        return null
      }

      return this.normalizeHexColor(color)
    },
    portalThemeStyles () {
      if (!this.tenantBrandColor) {
        return {}
      }

      const base = this.tenantBrandColor
      const lighter = this.adjustColor(base, 0.16)
      const darker = this.adjustColor(base, -0.12)
      const activeStart = this.adjustColor(base, 0.08)
      const activeEnd = this.adjustColor(base, -0.18)

      return {
        '--pm-cta-color': base,
        '--pm-cta-gradient': `linear-gradient(135deg, ${lighter}, ${darker})`,
        '--pm-cta-gradient-active': `linear-gradient(135deg, ${activeStart}, ${activeEnd})`,
        '--pm-cta-shadow': `0 12px 24px ${this.hexToRgba(base, 0.2)}`,
        '--pm-cta-hover-shadow': `0 14px 32px ${this.hexToRgba(base, 0.26)}`,
        '--pm-cta-border-hover': this.hexToRgba(base, 0.5),
        '--pm-cta-solid': base,
        '--pm-cta-solid-hover': this.adjustColor(base, -0.12),
      }
    },
    displayName () {
      const nombre = this.admin_datos && this.admin_datos.nombre ? this.admin_datos.nombre.trim() : ''
      const apellido = this.admin_datos && this.admin_datos.apellido ? this.admin_datos.apellido.trim() : ''
      const fullName = [nombre, apellido].filter(Boolean).join(' ')
      return fullName || this.userEmail || 'Usuario'
    },
    userEmail () {
      return this.admin_datos && this.admin_datos.email ? this.admin_datos.email : ''
    },
    userInitials () {
      const nombre = this.admin_datos && this.admin_datos.nombre ? this.admin_datos.nombre : ''
      const apellido = this.admin_datos && this.admin_datos.apellido ? this.admin_datos.apellido : ''
      const nameInitial = nombre.trim().charAt(0)
      const lastInitial = apellido.trim().charAt(0)
      const initials = `${nameInitial}${lastInitial}`.replace(/\s+/g, '')
      if (initials) {
        return initials.toUpperCase()
      }
      if (this.userEmail) {
        return this.userEmail.charAt(0).toUpperCase()
      }
      return 'US'
    },
    userRoleLabel () {
      if (!this.admin_datos) {
        return ''
      }
      if (this.admin_datos.user_type === 'property_manager') {
        return 'Administrador de propiedades'
      }
      if (this.admin_datos.user_type === 'lead_partner') {
        return 'Lead partner'
      }
      if (this.admin_datos.superadmin === 1 || this.admin_datos.superadmin === true) {
        return 'Superadministrador'
      }
      return 'Administrador'
    },
    companyName () {
      const tenant = this.admin_datos && this.admin_datos.user_type === 'lead_partner'
        ? this.admin_datos.lead_partner
        : this.admin_datos && this.admin_datos.empresa
          ? this.admin_datos.empresa
          : null
      if (!tenant) {
        return ''
      }
      return tenant.nombre || tenant.nombre_fantasia || tenant.razon_social || (tenant.atributos && (tenant.atributos.nombre || tenant.atributos.nombre_fantasia)) || ''
    }
  },
  mounted() {
    document.addEventListener('click', this.close)    
  },
  beforeDestroy () {
    document.removeEventListener('click',this.close)
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-n{
  z-index: 999;
  background-color: transparent;
  --pm-cta-gradient: linear-gradient(135deg,#0ea5e9,#2563eb);
  --pm-cta-gradient-active: linear-gradient(135deg,#0d8bd5,#1f3e92);
  --pm-cta-shadow: 0 12px 24px rgba(14,165,233,0.18);
  --pm-cta-hover-shadow: 0 14px 32px rgba(14,165,233,0.18);
  --pm-cta-border-hover: rgba(14,165,233,0.55);
  --pm-cta-solid: #2563eb;
  --pm-cta-solid-hover: #1d4ed8;
}
.logo{
  height:100%;
  width:250px;
  display:flex;
  align-items:center;
  gap:12px;
  padding:0 20px;
  box-sizing:border-box;
  float:left;  
}
.logo .top-brand-logo-frame {
  position:relative;
  z-index:9999;
  display:grid;
  place-items:center;
  width:180px;
  height:60px;
}
.logo .top-brand-logo {
  display:block;
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
  object-fit:contain;
  filter:
    drop-shadow(1px 0 0 rgba(255,255,255,.92))
    drop-shadow(-1px 0 0 rgba(255,255,255,.92))
    drop-shadow(0 1px 0 rgba(255,255,255,.92))
    drop-shadow(0 -1px 0 rgba(255,255,255,.92))
    drop-shadow(0 6px 14px rgba(0,0,0,.32));
}
.buscar-resultados{
  background: white;
  border: 1px solid rgba(0,0,0,0.2);
  width:300px;
  position: absolute;
  top: 56px;
  padding-bottom:15px;
  padding-top:15px;
  max-height:400px;
  overflow-y: scroll;

}

.buscandoIcons{
  color:#00B4CC;
  height:24px;
  width:24px;
  transform:translate(-3px, 3px);
}
.resultado{
  text-decoration: none;
  padding:5px 10px 5px 10px;
  /*border-top: 1px solid black;*/
}

.input-buscar{
  width:300px;
  border: 1px solid #00B4CC;
  border-top: none;
  border-right: none;
  border-left: none;

  padding: 15px 15px 15px 5px;
  height: 20px;
  outline: none;
}
.input-buscar::placeholder{
  color:rgba(0,0,0,0.4)
}
.buscar-barra{
  position:relative;
  padding: 25px 0;
  height:100%;
  vertical-align: middle;
  margin: auto;
  padding-left: 40px;
}
.nav-actions{
  position:absolute;
  right:20px;
  top:0px;
  height:100%;
  display:flex;
  align-items:center;
}
.universal-search{
  position:absolute;
  left:280px;
  right:430px;
  top:14px;
  min-width:280px;
  max-width:680px;
  height:52px;
  display:flex;
  align-items:center;
  border:1px solid rgba(148,163,184,0.35);
  border-radius:14px;
  background:#f8fafc;
  box-shadow:0 8px 22px rgba(15,23,42,0.06);
  transition:border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.universal-search.active{
  background:#ffffff;
  border-color:var(--pm-cta-border-hover, rgba(14,165,233,0.55));
  box-shadow:0 16px 38px rgba(15,23,42,0.14);
}
.universal-search-icon{
  margin-left:16px;
  color:#64748b;
  font-size:18px;
  flex-shrink:0;
}
.universal-search-input{
  width:100%;
  min-width:0;
  border:none;
  outline:none;
  background:transparent;
  padding:0 44px 0 12px;
  font-size:14px;
  font-weight:600;
  color:#0f172a;
  line-height:1.2;
}
.universal-search-input::placeholder{
  color:#94a3b8;
  font-weight:500;
}
.search-clear-button{
  position:absolute;
  right:10px;
  width:30px;
  height:30px;
  border:none;
  border-radius:50%;
  background:rgba(100,116,139,0.12);
  color:#64748b;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
}
.search-clear-button:hover{
  background:rgba(100,116,139,0.2);
  color:#0f172a;
}
.universal-search-results{
  position:absolute;
  top:60px;
  left:0;
  right:0;
  max-height:520px;
  overflow-y:auto;
  background:#ffffff;
  border:1px solid rgba(15,23,42,0.08);
  border-radius:14px;
  box-shadow:0 24px 56px rgba(15,23,42,0.18);
  padding:10px;
  z-index:10020;
}
.search-group + .search-group{
  margin-top:8px;
  padding-top:8px;
  border-top:1px solid rgba(226,232,240,0.9);
}
.search-group-title{
  padding:4px 8px 6px;
  font-size:10px;
  font-weight:800;
  text-transform:uppercase;
  color:#94a3b8;
  line-height:1;
}
.search-result-row{
  width:100%;
  min-height:54px;
  border:none;
  border-radius:10px;
  background:#ffffff;
  color:#0f172a;
  display:flex;
  align-items:center;
  gap:10px;
  padding:8px 10px;
  text-align:left;
  cursor:pointer;
}
.search-result-row:hover,
.search-result-row.selected{
  background:rgba(14,165,233,0.11);
}
.search-client-row{
  min-height:72px;
  align-items:flex-start;
  gap:12px;
  padding:10px;
  border:1px solid transparent;
}
.search-client-row:hover,
.search-client-row.selected{
  background:#f8fafc;
  border-color:rgba(14,165,233,0.22);
  box-shadow:0 10px 24px rgba(15,23,42,0.08);
}
.search-result-icon{
  width:28px;
  height:28px;
  border-radius:8px;
  background:rgba(14,165,233,0.12);
  color:#0ea5e9;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
  font-size:14px;
}
.search-client-icon{
  width:38px;
  height:38px;
  border-radius:10px;
  background:rgba(14,165,233,0.14);
  color:#0284c7;
  font-size:17px;
  margin-top:2px;
}
.search-result-copy{
  min-width:0;
  display:flex;
  flex-direction:column;
  gap:2px;
  flex:1;
}
.search-client-copy{
  min-width:0;
  display:flex;
  flex:1;
  flex-direction:column;
  gap:3px;
}
.search-client-heading{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
  min-width:0;
}
.search-result-title{
  font-size:13px;
  font-weight:700;
  color:#0f172a;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.search-result-subtitle{
  font-size:11px;
  color:#64748b;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.search-client-name{
  font-weight:700;
  color:#334155;
}
.search-client-contact{
  font-size:11px;
  color:#64748b;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.search-result-meta{
  font-size:10px;
  font-weight:700;
  color:#64748b;
  background:#f1f5f9;
  border-radius:999px;
  padding:4px 7px;
  max-width:96px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  flex-shrink:0;
}
.search-client-meta{
  background:#e0f2fe;
  color:#0369a1;
  max-width:82px;
}
.search-client-open{
  width:28px;
  height:28px;
  border-radius:50%;
  display:flex;
  align-items:center;
  justify-content:center;
  color:#64748b;
  background:#f1f5f9;
  flex-shrink:0;
  font-size:18px;
  margin-top:5px;
}
.search-client-row:hover .search-client-open,
.search-client-row.selected .search-client-open{
  background:var(--pm-cta-solid, #2563eb);
  color:#ffffff;
}
.universal-search-state,
.universal-search-hint{
  min-height:58px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
  color:#64748b;
  font-size:13px;
  font-weight:600;
}
.universal-search-state.error{
  color:#be123c;
}
.user-trigger{
  display:inline-flex;
  align-items:center;
  justify-content:flex-start;
  gap:14px;
  border:1px solid rgba(148,163,184,0.35);
  background:#ffffff;
  padding:6px 18px 6px 8px;
  border-radius:999px;
  font-weight:600;
  color:#0f172a;
  cursor:pointer;
  transition:box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
  min-width:360px;
  max-width:520px;
  box-shadow:0 6px 20px rgba(15,23,42,0.08);
  min-height:60px;
}
.user-trigger:hover{
  border-color:var(--pm-cta-border-hover, rgba(14,165,233,0.55));
  box-shadow:var(--pm-cta-hover-shadow, 0 14px 32px rgba(14,165,233,0.18));
  transform:translateY(-1px);
}
.trigger-icon{
  font-size:16px;
  color:#64748b;
  flex-shrink:0;
}
.avatar{
  width:48px;
  height:48px;
  min-width:48px;
  min-height:48px;
  border-radius:50%;
  background:var(--pm-cta-gradient, linear-gradient(135deg,#0ea5e9,#2563eb));
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:700;
  font-size:16px;
  color:#ffffff;
  flex:0 0 48px;
  box-sizing:border-box;
}
.avatar-lg{
  width:60px;
  height:60px;
  min-width:60px;
  min-height:60px;
  font-size:18px;
  flex:0 0 60px;
}
.user-meta{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  line-height:1.15;
  min-width:0;
  flex:1;
}
.user-name{
  font-size:14px;
  font-weight:600;
  color:#0f172a;
  max-width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  align-self:flex-start;
  text-align:left;
}
.user-role{
  font-size:12px;
  color:#64748b;
  text-transform:capitalize;
  line-height:1.4;
  margin-top:2px;
  white-space:normal;
  word-break:break-word;
  align-self:flex-start;
  text-align:left;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.right{
  background-color: white;
  display:block;
  height:100%;
  width: Calc(100% - 250px);
  text-align: left;
  margin-left:0px;
  float:left;

}
.main-top-nav{
  position:fixed;
  height:80px;
  width:100%;
      -webkit-box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0px 10px 0 rgba(0, 0, 0, 0.1);
  background: white;
  z-index:999;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.dropdown-menu-x{
  position:fixed;
  height:auto;
  width:380px;
  max-width:min(94%, 420px);
  right:24px;
  top:84px;
  z-index:10000;
  background:#ffffff;
  border-radius:16px;
  border:1px solid rgba(15,23,42,0.08);
  box-shadow:0 24px 60px rgba(15,23,42,0.18);
  padding:20px 20px 12px 20px;
}
.user-card{
  display:flex;
  gap:16px;
  align-items:center;
  background:linear-gradient(135deg,#0f172a,#1e293b);
  color:#f8fafc;
  padding:18px 20px;
  border-radius:12px;
  margin-bottom:16px;
}
.user-card-body{
  flex:1;
}
.user-card-name{
  font-size:18px;
  font-weight:600;
}
.user-card-email{
  font-size:13px;
  opacity:0.85;
  margin-top:4px;
  word-break:break-word;
}
.chip-row{
  display:flex;
  flex-wrap:wrap;
  gap:8px;
  margin-top:12px;
}
.chip{

  align-items:center;
  padding:4px 12px;
  border-radius:999px;
  font-size:11px;
  font-weight:600;
  letter-spacing:0.01em;
 
  white-space:normal;

  line-height:1.3;
  text-align: left; 
}
.chip-primary{
  background:rgba(255,255,255,0.18);
  color:#e0f2fe;
  border:1px solid rgba(255,255,255,0.35);
}
.chip-secondary{
  background:rgba(14,165,233,0.12);
  color:#0ea5e9;
  border:1px solid rgba(14,165,233,0.25);
}
.dropdown-section{
  padding:4px 0;
}
.dropdown-item{
  width:100%;
  display:flex;
  gap:12px;
  align-items:flex-start;
  padding:12px 14px;
  border-radius:12px;
  border:none;
  background:rgba(15,23,42,0.02);
  color:#0f172a;
  text-align:left;
  cursor:pointer;
  transition:background 0.2s ease, transform 0.2s ease;
  font:inherit;
  text-decoration:none;
}
.dropdown-item:hover{
  background:rgba(14,165,233,0.15);
  transform:translateY(-1px);
}
.dropdown-item.logout{
  background:rgba(244,63,94,0.08);
  color:#be123c;
}
.dropdown-item.logout:hover{
  background:rgba(244,63,94,0.14);
}
.item-icon{
  width:34px;
  height:34px;
  border-radius:50%;
  display:flex;
  align-items:center;
  justify-content:center;
  background:rgba(14,165,233,0.14);
  color:#0ea5e9;
  flex-shrink:0;
  font-size:18px;
}
.dropdown-item.logout .item-icon{
  background:rgba(244,63,94,0.16);
  color:#be123c;
}
.item-copy{
  display:flex;
  flex-direction:column;
  gap:2px;
}
.item-title{
  font-size:14px;
  font-weight:600;
}
.item-subtitle{
  font-size:12px;
  color:#64748b;
}
.dropdown-footer-note{
  margin:12px 2px 0;
  font-size:11px;
  color:#94a3b8;
  text-align:center;
}
.loader-wrapper{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  padding:40px 0;
  gap:12px;
}
.loader-text{
  font-size:14px;
  color:#64748b;
}

.mobile-menu-button {
  display: none;
  place-items: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 12px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.mobile-menu-button:focus-visible {
  outline: 3px solid rgba(14, 165, 233, 0.28);
  outline-offset: 2px;
}


@media (max-width: 800px) {
  .logo{
    width:112px;
    padding:0 10px;
    gap:8px;
  }
  .mobile-menu-button {
    display:grid;
  }
  .logo .top-brand-logo-frame {
    width:42px;
    height:48px;
  }
  .main-n{
    position: fixed;
    top:0px;
  }
  .universal-search{
    left:124px;
    right:12px;
    top:12px;
    height:54px;
    max-width:none;
  }
  .nav-actions{
    display:none;
  }
}

@media (max-width: 640px) {
  .universal-search{ min-width:0; }
  .universal-search-input{
    font-size:13px;
  }
  .search-result-meta{
    display:none;
  }
  .user-trigger{
    min-width:0;
    max-width:100%;
    width:auto;
    padding:10px 16px 10px 12px;
    gap:12px;
  }
  .avatar{
    width:36px;
    height:36px;
  }
}

.slide-enter-active,
.slide-leave-active {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-name: slide;
}

.slide-leave-active {
  animation-direction: reverse;
}

@keyframes slide {
  from {
    opacity: 1;
    transform: translateX(-300px);
  }

  100% {
    opacity: 1;
  }
}
</style>
